<template lang="pug">
div
  p(v-for="(t, idx) in AVAILABLE_TYPE_LIST" :key="idx")
    v-btn(
      color="secondary"
      block
      large
      rounded
      :outlined="!(type && type === t.type)"
      @click="type = t.type"
    )
        v-icon.mr-2 {{ t.icon }}
        span {{ t.text }}
</template>
<script>
import { ACCOUNT_TYPE } from '../constants';

export default {
  data() {
    return {
      type: null,
      AVAILABLE_TYPE_LIST: [
        { type: ACCOUNT_TYPE.organization, text: 'Я организация', icon: 'mdi-account-details-outline' },
        { type: ACCOUNT_TYPE.teacher, text: 'Я учитель', icon: 'mdi-account-outline' },
        { type: ACCOUNT_TYPE.student, text: 'Я обучающийся', icon: 'mdi-certificate-outline' },
      ],
    };
  },
  watch: {
    type(val) {
      this.$emit('input', val);
    },
  },
};
</script>
